export function validateBadmintonFinalScore(team1: number, team2: number) {
  if (!Number.isInteger(team1) || !Number.isInteger(team2)) {
    return { ok: false, message: 'Scores must be whole numbers.' };
  }
  if (team1 < 0 || team2 < 0) {
    return { ok: false, message: 'Scores cannot be negative.' };
  }
  if (team1 > 30 || team2 > 30) {
    return { ok: false, message: 'Max score is 30.' };
  }
  if (team1 === team2) {
    return { ok: false, message: 'Final score cannot be a tie.' };
  }

  const hi = Math.max(team1, team2);
  const lo = Math.min(team1, team2);
  const diff = hi - lo;

  if (hi < 21) {
    return { ok: false, message: 'Winner must have at least 21 points.' };
  }

  if (diff >= 2) {
    return { ok: true, message: '' };
  }

  return { ok: false, message: 'Must win by at least 2 points.' };
}
